import { FormControlLabel, Radio } from '@mui/material';
import Typography from '../Typography';
import { StyledRadioGroup } from './styles';

import { IRadioGroup } from './types';

const RadioGroup = ({ name, onChange, value, options, row, gap, size }: IRadioGroup) => {
  return (
    <StyledRadioGroup name={name} onChange={onChange} value={value} row={row} $gap={gap}>
      {options.map(({ value, label, id, disabled }) => (
        <FormControlLabel
          key={id}
          value={value}
          control={<Radio size={size} sx={{ color: 'primary.main' }} />}
          label={<Typography fontSize={'14px'}>{label}</Typography>}
          disabled={disabled}
        />
      ))}
    </StyledRadioGroup>
  );
};

export default RadioGroup;
